import React from 'react';
import CollapseArrow from "../../../../images/arrowexpanmodules.svg";
import moment from "moment/moment";
import { Avatar, Collapse, Divider } from "antd";
import iconDown from "../../../../images/icon-linkedin.svg";
import { convertToLocalTime } from "../../../../utils/format";
import CollapseModules from "../../../CertificateDashboard/CollapseModules";

const { Panel } = Collapse

export default function ProgramSchedule({ program }) {

  return (
    <div>
      {program?.CourseClasses.map(e => {
        if (e.isSubclasse) return null

        let startDate = convertToLocalTime(e?.startDate, e?.timezone);
        let startTime = convertToLocalTime(e?.startTime, e?.timezone);
        let endTime = convertToLocalTime(e?.endTime, e?.timezone);

        return (
          <Collapse
            ghost
            expandIcon={({ isActive }) => (
              <div className="truc-shadow-module">
                <img
                  src={CollapseArrow}
                  style={
                    isActive
                      ? {
                        transform: "rotate(0deg)",
                        transition: "all 0.4s ease-in-out",
                        padding: "0px",
                        marginRight: "5px",
                      }
                      : {
                        transform: "rotate(90deg)",
                        transition: "all 0.4s ease-in-out",
                        padding: "0px",
                        marginRight: "5px",
                      }
                  }
                  alt="arrow-collapse"
                />
              </div>
            )}
          >
            <Panel
              header={
                <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                  {startDate.format("dddd, MMMM DD")}
                  <sup>{startTime.format("Do").slice(-2)}</sup>
                </div>
              }
              // key={index}
              // className="site-collapse-custom-panel"
            >
              <div
                // style={{
                //   maxHeight: "calc(100svh - 104px)",
                //   overflowY: "auto"
                // }}
                // className={"container-collapse-module"}
              >
                <div
                  // className={"container-collapse-module-content"}
                >
                  <div
                    // className={"left-segment-collapse"}
                  >
                    <h2>{e.title}</h2>
                    <div
                      style={{
                        margin: "0px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      <div
                        className={"container-descriptionnn"}
                        dangerouslySetInnerHTML={{
                          __html: e?.descriptionForCertificate,
                        }}
                      />
                    </div>
                    <>
                      <p
                        style={{
                          margin: "0px",
                          marginTop: "1rem",
                          marginBottom: "5px",
                        }}
                      >
                        <b>Class Date</b>:
                        {` ${(startDate || moment())?.format("LL")}`}
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        <b>Class Start Time:</b>{" "}
                        {(startTime || moment())?.format("HH:mm")}{" "}
                        {moment.tz.guess()}
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        <b>Class End Time:</b>{" "}
                        {(endTime || moment())?.format("HH:mm")}{" "}
                        {moment.tz.guess()}
                      </p>
                      {/*{enrolled &&*/}
                      {/*  moment*/}
                      {/*    .utc(*/}
                      {/*      moment*/}
                      {/*        .tz("America/Los_Angeles")*/}
                      {/*        .format("YYYY-MM-DDTHH:mm:ss") + "Z",*/}
                      {/*    )*/}
                      {/*    .isBefore(moment.utc(e?.endTime)) && (*/}
                      {/*    <ButtonsCalendar*/}
                      {/*      panels={e}*/}
                      {/*      slug={program?.slug}*/}
                      {/*      linkToJoin={e?.linkToJoin}*/}
                      {/*    />*/}
                      {/*  )}*/}
                    </>
                    {/*{e?.videoLink && (*/}
                    {/*  <div*/}
                    {/*    style={{*/}
                    {/*      display: "flex",*/}
                    {/*      alignItems: "center",*/}
                    {/*      height: "100%",*/}
                    {/*      marginTop: "1rem",*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    <div*/}
                    {/*      className="title-list-certificates-dash"*/}
                    {/*      onClick={() => setModal3(e)}*/}
                    {/*    >*/}
                    {/*      CLASS VIDEO*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*)}*/}
                  </div>
                  <div className={"right-segment-collapse"}>
                    {(e?.intructors || []).map((ins, index) => {
                      return (
                        <div
                          className={"module-card-user-collapse"}
                          key={index}
                        >
                          <Avatar src={ins?.img} size={120}></Avatar>
                          <Divider className={"module-divider-collapse"} />
                          <h3
                            className={"module-name-collapse"}
                          >{`${ins?.firstName} ${ins?.lastName}`}</h3>
                          <p style={{ fontSize: "15px" }}>
                            {ins?.titleProfessions}
                          </p>
                          <a
                            href={ins?.linkedin || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className={"module-icon-linkedin"}
                              src={iconDown}
                              alt="linkedin"
                            />
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  className={"container-background-subclass"}
                  style={{ background: "#fafafa" }}
                >
                  {e?.guestLectures?.map((panel, index2) => {
                    let startDate2 = convertToLocalTime(
                      panel?.startDate,
                      e?.timezone,
                    );
                    let startTime2 = convertToLocalTime(
                      panel?.startTime,
                      e?.timezone,
                    );
                    let endTime2 = convertToLocalTime(
                      panel?.endTime,
                      e?.timezone,
                    );
                    return (
                      <CollapseModules
                        title={
                          <>
                            {startDate2.format("dddd, MMMM DD")}
                            <sup>{startTime2.format("Do").slice(-2)}</sup>
                          </>
                        }
                        background={"transparent"}
                        key={index2}
                        content={
                          <div className={"container-collapse-module"}>
                            <div
                              className={"container-collapse-module-content"}
                            >
                              <div className={"left-segment-collapse"}>
                                <h2>{panel?.title}</h2>
                                <div
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <div
                                    className={"container-descriptionnn"}
                                    dangerouslySetInnerHTML={{
                                      __html: panel?.description,
                                    }}
                                  />
                                </div>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <b>Class Date</b>:
                                  {` ${startDate2?.format("LL")}`}
                                </p>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <b>Class Start Time:</b>{" "}
                                  {startTime2?.format("HH:mm a")}{" "}
                                  {moment.tz.guess()}
                                </p>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <b>Class End Time:</b>{" "}
                                  {endTime2?.format("HH:mm a")}{" "}
                                  {moment.tz.guess()}
                                </p>
                                {/*{enrolled && (*/}
                                {/*  <ButtonsCalendar*/}
                                {/*    panels={panel}*/}
                                {/*    slug={program?.slug}*/}
                                {/*    linkToJoin={e?.linkToJoin}*/}
                                {/*  />*/}
                                {/*)}*/}
                              </div>
                              <div className={"right-segment-collapse"}>
                                {panel?.intructors.map((ins, index) => {
                                  return (
                                    <div
                                      className={"module-card-user-collapse"}
                                      key={index}
                                    >
                                      <Avatar
                                        src={ins?.img}
                                        size={120}
                                      ></Avatar>
                                      <Divider
                                        className={"module-divider-collapse"}
                                      />
                                      <h3
                                        className={"module-name-collapse"}
                                      >{`${ins?.firstName} ${ins?.lastName}`}</h3>
                                      <p style={{ fontSize: "15px" }}>
                                        {ins?.titleProfessions}
                                      </p>
                                      <a
                                        href={ins?.linkedin || "#"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          className={"module-icon-linkedin"}
                                          src={iconDown}
                                          alt="linkedin"
                                        />
                                      </a>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        }
                      />
                    );
                  })}
                </div>
              </div>
            </Panel>
          </Collapse>
        )
      })}
    </div>
  )
}